<script lang="ts" setup>
import type { ScheduleEvent } from '~/types'

defineOptions({
  name: 'Ticker',
})

interface Props {
  scheduleEvents?: ScheduleEvent.Model[]
  isLoading: boolean
}

const props = withDefaults(defineProps<Props>(), {
  scheduleEvents: () => [],
})

const hasItems = computed<boolean>(() => props.scheduleEvents.length > 0)
</script>

<template>
  <div class="schedule-events-ticker__slider">
    <UILoadingCard
      v-if="isLoading"
      class="schedule-events-ticker__loading"
    />
    <ScheduleEventsTickerSwiper
      v-else-if="hasItems"
      :schedule-events
      class="schedule-events-ticker__swiper"
    />
    <div
      v-else
      class="schedule-events-ticker__empty"
    >
      No events found
    </div>
  </div>
</template>

<style scoped lang="scss">
.schedule-events-ticker {
  &__slider {
    @apply shrink-0 w-full flex items-center justify-between mt-[20px];
    @apply xl:w-[calc(100%-300px)] xl:mt-0;
  }
}
</style>
